import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth/auth.service';
import { BanksService } from '../bank-management/banks.service';
import { ManageTicketServiceService } from '../manage-tickets/manage-ticket-service.service';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CountdownComponent } from 'ngx-countdown';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MtbService } from '../services/mtb.service';
@Component({
  selector: 'app-move-to-bank',
  templateUrl: './move-to-bank.component.html',
  styleUrls: ['./move-to-bank.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})
export class MoveToBankComponent implements OnInit {
  typeI:any='IMPS'
  form: FormGroup;
  private formSubmitAttempt: boolean;
  private formOtpSubmitAttempt: boolean;
  retailor_phoneNumber: any;
  isValidOtp: boolean = false;
  isSubmit: boolean = false;
  walletAmount: Object;
  transactiontype: any = "IMPS"
  userCurrenPosition: any;
  uacid: string;
  dataSource: any;
  otpform: FormGroup;
  status = 'ready';
  @ViewChild('countdown') counter: CountdownComponent;
  isResendEnable: boolean = false;
  uniqueTransactionNumber: any;
  noteData: any;
  noteDataIMPS: any;
  isServiceInactive: boolean=false;
  serviceData: any;
  @ViewChild("serviceModal") modalContent: TemplateRef<any>;
 
  constructor(
    private mtbService: MtbService,
    private authService: AuthService,
    public service: ManageTicketServiceService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private bankService: BanksService,
    private router: Router,
    private ngxService: NgxUiLoaderService,
    config: NgbModalConfig, private modalService: NgbModal

  ) {
    config.backdrop = 'static';
    config.keyboard = false;
    this.retailor_phoneNumber = localStorage.getItem('retailor_phoneNumber')
    this.form = this.fb.group({
      amount: ['', Validators.required],
      comments: ['', Validators.required],
      otpOn:['MOBILE',Validators.required]
    });
    this.otpform = this.fb.group({
      otp: ['', Validators.required],
    });
  }
  isFieldInvalid(field: string) {
    return (
      (!this.form.get(field).valid && this.form.get(field).touched) ||
      (this.form.get(field).untouched && this.formSubmitAttempt)
    );
  }
  isOtpFieldInvalid(field: string) {
    return (
      (!this.otpform.get(field).valid && this.otpform.get(field).touched) ||
      (this.otpform.get(field).untouched && this.formOtpSubmitAttempt)
    );
  }

  close(content) {
    this.modalService.dismissAll(content);
  }
  fetchBanks() {
    this.bankService.userbanks2().subscribe((banksList: any) => {
      this.dataSource = banksList.object;
    })
  }
  ngOnDestroy(): void {
  }
  changeBank() {
    this.router.navigate(['/bank-management']);
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnInit() {
    this.fetchBanks();

    this.fetchWalletBalance();
    this.getLocationDetails();
    this.getactiveAlert();
    this.getactiveAlert2();
    this.getServiceAlert('CF_IMPS');

  }
  getServiceAlert(service){
    this.authService.getserviceAlert(service).subscribe((res: any) => {
      if (res.status_code == 1) {
          // res.object;
      } else {
        // this.toast.error(res.error.message);
        this.isServiceInactive=true;
        this.serviceData=res.error;
        this.modalService.open(this.modalContent);


      }
    }, errData => {
      this.ngxService.stop()
                 
    })

}

  getactiveAlert(){
    this.ngxService.start()
    
    this.authService.getactiveAlert('CF_NEFT').subscribe((res: any) => {
      this.ngxService.stop()
      if (res.status_code == 1) {
          this.noteData=res.object;
      } else {
        // this.toastr.error(res.error.message);

      }
    }, errData => {
      this.ngxService.stop()
    })
  }
  
  getactiveAlert2(){
    this.ngxService.start()
    
    this.authService.getactiveAlert('CF_IMPS').subscribe((res: any) => {
      this.ngxService.stop()
      if (res.status_code == 1) {
          this.noteDataIMPS=this.noteData;

      } else {
        // this.toastr.error(res.error.message);

      }
    }, errData => {
      this.ngxService.stop()
    })
  }
  closeServiceModal(serviceModal){
    this.modalService.dismissAll(serviceModal);
    this.router.navigate(['/dashboard']);

  }
  closeServiceModalOut(serviceModal){
    this.modalService.dismissAll(serviceModal);
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  getLocationDetails() {
    if (navigator.geolocation) {
      let _this = this
      navigator.geolocation.getCurrentPosition(function (postion) {
        _this.userCurrenPosition = postion;
      });
    }
  }
  handleEvent(event) {
    if (event.action == 'finished') {
      this.isResendEnable = true;
    }
  }
  sendOTP(content) {
    this.formSubmitAttempt = true;
    if (this.form.invalid) {return;}
    this.ngxService.start()
    this.mtbService.sendOtp(this.form.value, this.transactiontype, this.userCurrenPosition?.coords).subscribe((res: any) => {
      this.ngxService.stop()
      if (res.status_code == 1) {
        this.modalService.open(content);
        this.uniqueTransactionNumber = res.object.transactionUniqueNummber;
      }
    }, errData => {
      this.ngxService.stop()
    })

  }
  resendOTP() {
    this.ngxService.start()
    this.mtbService.resendOtp(this.uniqueTransactionNumber).subscribe((res: any) => {
      this.ngxService.stop()
      if (res.status_code == 1) {
        this.isResendEnable = false;

      } else {
        this.toastr.error(res.error.message);

      }
    }, errData => {
      this.ngxService.stop()
    })


  }
  validateOTP(form, content) {
    this.formOtpSubmitAttempt = true;
    if (this.otpform.invalid) {
      return;
    }
    this.ngxService.start()
    this.mtbService.movetobank(this.otpform.value, this.uniqueTransactionNumber).subscribe((res: any) => {
      this.ngxService.stop()
      if (res.status_code == 1) {
        this.toastr.success(res.message);
        this.form.controls['amount'].reset();
        this.form.controls['comments'].reset();
        this.router.navigate(['/dashboard']);
        this.isValidOtp = false;
        this.isSubmit = false;
        this.close(content);
      } else {
        this.toastr.error(res.error.message);

      }
    }, err => {
      this.ngxService.stop()
      // this.toastr.error(err.error.message);
    })
  }
  fetchWalletBalance() {
    this.authService.getRetailerWalletBalance().subscribe((res: any) => {
      this.walletAmount = res.balance;
    });
  }
  M2bMode(event) {
    this.transactiontype = event.value;
    if(this.transactiontype=='NEFT'){
      var serviceALertType='CF_NEFT';
      this.getServiceAlert(serviceALertType);

    }else if(this.transactiontype=='IMPS'){
      var serviceALertType='CF_IMPS';
      this.getServiceAlert(serviceALertType);

    }

  }

}
